module.exports = __webpack_public_path__ + "statics/img/bank-card-1.6c2851dd.png";